<template>
  <v-form
    lazy-validation
    v-model="valid"
    @submit.prevent="submit"
    ref="form"
  >
      <v-row>
        <v-col cols="12" xs="12" sm="12" xl="4" lg="4">
          <v-text-field
            filled
            data-cy="FormMapItem-name"
            :label="$$t('name')"
            v-model="localMapItem.name"
          />
        </v-col>
        <v-col cols="12" xs="12" sm="12" xl="4" lg="4">
          <v-select
            :items="states"
            item-value="text"
            :item-text="(s) => $t(`Membership.ReadinessDisplay.${s.text}`)"
            label="Gereedsheidstand"
            v-model="localMapItem.state"
          ></v-select>
        </v-col>
        <!-- <v-col cols="12" xs="12" sm="12" xl="4" lg="4">
          <v-text-field
            filled
            data-cy="FormMapItem-regionalLeader"
            :label="$$t('regionalLeader')"
            v-model="localMapItem.regionalLeader"
          />
        </v-col> -->
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-switch
            class="mt-6 float-right"
            v-model="showDetail"
            :label="$$t('btnDetail')"
          ></v-switch>
        </v-col>
      </v-row>
      <vue-editor
        v-show="showDetail"
        v-model="localMapItem.leaderContact"
        data-cy="FormMapItem-leaderContact"
      />
      <v-color-picker
        v-show="showDetail"
        data-cy="FormMapItem-strokeColour"
        :label="$$t('strokeColour')"
        @input="strokeColourChanged"
        v-model="colour"
      />
      <div class="d-flex justify-end mb-6">
        <v-btn color="default" outlined class="ml-4 btn-cancel" @click="cancel"
          data-cy="FormMapItem-button-cancel">
          {{ $t('common.buttons.cancel') }}
        </v-btn>
        <v-btn color="primary" type="submit" class="ml-4" :loading="$parent.isSaving"
          data-cy="FormMapItem-button-save">
            {{ $t('common.buttons.save') }}
          </v-btn>
      </div>
  </v-form>
</template>

<script>
import { VueEditor } from 'vue2-editor';
import states from '../states.json';

export default {
  name: 'FormMapItem',
  module: 'MapItem',
  components: { VueEditor },
  props: {
    /**
    * Set the text box value. Default: undefined,
    */
    MapItem: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      states,
      /**
      * Hold colour picker value
      */
      colour: '#ffffff',
      /**
      * Hold form validation state
      */
      valid: false,
      /**
      * Local value used for property localMapItem
      */
      localMapItem: {},
      /**
      * Hold form detailed state
      */
      showDetail: false,
    };
  },
  watch: {
    MapItem() {
      this.localMapItem = this.MapItem;
      this.colour = this.MapItem.strokeColour;
      this.$log.trace(`MapItem updated: ${JSON.stringify(this.MapItem)}`);
    },
  },
  created() {
    this.localMapItem = this.MapItem;
  },
  methods: {
    /** Colour Picker colour changed event handler
     */
    strokeColourChanged(val) {
      this.$log.trace(`Stroke Colour selected: ${JSON.stringify(val)}`);
      this.localMapItem.strokeColour = val.hex;
    },
    /** Submit Form data trigger
     * @event save
     * @type {object}
     */
    submit() {
      // validate
      if (this.$refs.form.validate()) {
        this.$emit('save', this.localMapItem);
      }
    },
    /** Cancel form trigger
     * @event cancel
     */
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<docs>
# FormMapItem example

'''js
<FormMapItem :MapItem="MapItem" />
'''
</docs>
